import { render } from "./MyRecords.vue?vue&type=template&id=634a9e82&scoped=true&ts=true"
import script from "./MyRecords.vue?vue&type=script&lang=ts"
export * from "./MyRecords.vue?vue&type=script&lang=ts"

import "./MyRecords.vue?vue&type=style&index=0&id=634a9e82&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634a9e82"]])

export default __exports__